/**
 * our-stores-tabs.js
 * Momentz Store Locator — Path URLs + query param fallback
 * Vanilla JS only. No external libraries.
 */

(function () {
  'use strict';

  const BASE_PATH    = '/pages/storelocator-new';
  const DEFAULT_CITY = 'delhi';

  const tabs   = document.querySelectorAll('.our-stores-tab');
  const panels = document.querySelectorAll('.our-stores-panel');

  if (!tabs.length || !panels.length) return;

  // ── Read city from path: /pages/storelocator-new/lucknow ────
  function getCityFromPath() {
    const match = window.location.pathname.match(
      new RegExp('^' + BASE_PATH + '/([^/?#]+)')
    );
    return match ? match[1] : null;
  }

  // ── Read city from query param: ?city=lucknow ────────────────
  function getCityFromQuery() {
    return new URLSearchParams(window.location.search).get('city');
  }

  function isValidCity(slug) {
    return !!document.querySelector('[data-city="' + slug + '"]');
  }

  // ── Core: activate a tab ─────────────────────────────────────
  function activateCity(citySlug, pushState) {
    if (!isValidCity(citySlug)) citySlug = DEFAULT_CITY;

    // Update tab aria states
    tabs.forEach(function (tab) {
      const isActive = tab.dataset.city === citySlug;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Show / hide panels
    panels.forEach(function (panel) {
      if (panel.id === 'our-panel-' + citySlug) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Push clean path URL — no reload
    if (pushState) {
      const newURL = BASE_PATH + '/' + citySlug;
      history.pushState({ city: citySlug }, '', newURL);
    }
  }

  // ── Tab click ────────────────────────────────────────────────
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateCity(tab.dataset.city, true);
    });
  });

  // ── Keyboard navigation ──────────────────────────────────────
  tabs.forEach(function (tab, index) {
    tab.addEventListener('keydown', function (e) {
      let targetIndex = null;
      if (e.key === 'ArrowRight') targetIndex = (index + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') targetIndex = (index - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') targetIndex = 0;
      else if (e.key === 'End')  targetIndex = tabs.length - 1;

      if (targetIndex !== null) {
        e.preventDefault();
        tabs[targetIndex].focus();
        activateCity(tabs[targetIndex].dataset.city, true);
      }
    });
  });

  // ── Browser back / forward ───────────────────────────────────
  window.addEventListener('popstate', function (e) {
    const city = (e.state && e.state.city)
      ? e.state.city
      : (getCityFromPath() || getCityFromQuery());
    activateCity(city || DEFAULT_CITY, false);
  });

  // ── Init: path first, then query param, then default ─────────
  (function init() {
    const city =
      getCityFromPath()  ||   // direct visit via pushState
      getCityFromQuery() ||   // landed via redirect (?city=lucknow)
      DEFAULT_CITY;

    const resolved = isValidCity(city) ? city : DEFAULT_CITY;
    activateCity(resolved, false);

    // Clean up query param from URL after reading it
    if (getCityFromQuery()) {
      history.replaceState({ city: resolved }, '', BASE_PATH + '/' + resolved);
    } else {
      history.replaceState({ city: resolved }, '', window.location.href);
    }
  })();

})();